import './league-list.styles.scss';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { phaseLabel } from '@/utils/leagueLabels';
import ThreeDotsLoader from '@/components/loader/three-dots-loader.component';

// The leagues you manage a team in, then the leagues with open teams.
// leagues: {id: league document}.
const LeagueList = ({ leagues, appId }) => {

    const navigate = useNavigate();

    if (!leagues || !appId) return <div className='center-col'><ThreeDotsLoader /></div>;

    // Old-format leagues (from before Phase 2) have no settings; hide them.
    const all = Object.values(leagues)
        .filter(l => l.settings && l.status === 'active')
        .sort((a, b) => a.name.localeCompare(b.name));
    const mine = all.filter(l => l.managers?.[appId]);
    const open = all.filter(l => !l.managers?.[appId] && openTeams(l) > 0);

    const card = (l, to, action) => (
        <button key={l.id} className='g-card league-card' onClick={() => navigate(to)}>
            <div className='league-card-main'>
                <div className='league-name'>{l.name}</div>
                <div className='meta'>
                    {l.type === 'pro' ? 'Pro' : 'College'} · {l.settings.teamCount} teams · {phaseLabel(l.season, l.type)}
                </div>
                <div className='league-action'>{action}</div>
            </div>
            <FontAwesomeIcon icon={faChevronRight} />
        </button>
    );

    return (
        <div className='league-list'>
            {mine.length > 0 &&
                <section>
                    <h2 className='list-title'>My leagues</h2>
                    <div className='league-cards'>
                        {mine.map(l => card(l, `/home/${l.id}`, 'Go to my team'))}
                    </div>
                </section>
            }
            <section>
                <h2 className='list-title'>Join a league</h2>
                {open.length === 0 ?
                    <div className='g-card'><p className='empty'>No leagues have open teams right now.</p></div> :
                    <div className='league-cards'>
                        {open.map(l => card(l, `/leagues/${l.path}`, `${openTeams(l)} open team${openTeams(l) === 1 ? '' : 's'} · Choose a team`))}
                    </div>
                }
            </section>
        </div>
    )
}

function openTeams(league) {
    return league.settings.teamCount - (league.managerIds?.length ?? 0);
}

export default LeagueList
